import { render, staticRenderFns } from "./BlockSlideFormText.vue?vue&type=template&id=022a5702&"
import script from "./BlockSlideFormText.vue?vue&type=script&lang=js&"
export * from "./BlockSlideFormText.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports